var map = {
	"./questions_en": "cf8b",
	"./questions_en.json": "cf8b",
	"./questions_es": "2454",
	"./questions_es.json": "2454",
	"./questions_fr": "290c",
	"./questions_fr.json": "290c",
	"./questions_purezone_en": "0f60",
	"./questions_purezone_en.json": "0f60",
	"./questions_purezone_es": "c892",
	"./questions_purezone_es.json": "c892",
	"./questions_purezone_fr": "6a93",
	"./questions_purezone_fr.json": "6a93"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "223d";